import React from 'react';
import { useLoading } from '../loading/LoadingContext';
import LoadingOverlay from '../loading/LoadingOverlay';

interface PicassoLayoutProps {
  children: React.ReactNode;
}

const PicassoLayout: React.FC<PicassoLayoutProps> = ({ children }) => {
  const { isLoading, loadingMessage } = useLoading();

  return (
    <>
      {children}
      <LoadingOverlay isVisible={isLoading} message={loadingMessage} />
    </>
  );
};

export default PicassoLayout;
